import React, { Fragment } from "react";
import { Link, matchPath } from "react-router-dom";
import Footer from "../components/Footer";
import Loader from "../components/Loader";
import {
  SITENAMEALIAS,
  SITENAME,
  LOGO,
  CAPTCHASITEKEY,
  DEMOBROKER,
} from "../utils/init";
import { showToast, showHttpError } from "../utils/library";
import { MerchantResetPassword } from "../utils/service";
import PaybitoCaptcha from "../components/PaybitoCaptcha";
import logo from "../assets/images/paybitologo.png";
import { updateFavicon } from "../utils/favicon";
import { Helmet } from "react-helmet";

export default class ResetPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      isPasswordMatched: false,
      secureToken: "",
      merchantId: "",
      eye: true,
      password: "password",
      type: false,
    };

    /*** REFERENCE FOR RETRIEVING INPUT FIELDS DATA ***/
    this.passwordRef = React.createRef();
    this.confirmPasswordRef = React.createRef();
    this.captchaRef = React.createRef();

    /* binding method */
    this.handlePasswordMatched = this.handlePasswordMatched.bind(this);
    this.handleResetPassword = this.handleResetPassword.bind(this);
  }

  componentDidMount() {
    updateFavicon();
  }

  /* 
    Method defination for checking if password and confirm password matched or not  
    */
  handlePasswordMatched = () => {
    let isMatched = false;
    if (
      this.passwordRef.current.value === this.confirmPasswordRef.current.value
    ) {
      isMatched = true;
    } else {
      isMatched = false;
    }
    this.setState({ isPasswordMatched: isMatched });
  };

  Eye = () => {
    if (this.state.password == "password") {
      this.setState({
        password: "text",
        eye: false,
        type: true,
      });
    } else {
      this.setState({
        password: "password",
        eye: true,
        type: false,
      });
    }
  };
  /* 
    Method defination for sending email and password and initiate login procedure through API Call
    */
  handleResetPassword = async (e) => {
    e.preventDefault();
    if (
      !this.passwordRef.current.value ||
      !this.confirmPasswordRef.current.value ||
      !this.state.isPasswordMatched
    ) {
      showToast("error", "Please provide valid password address ");
      return;
    }
    try {
      const { token } = await this.captchaRef.current.verify();
      this.handleCaptchaSubmit(token);
    } catch (err) {
      showToast("error", err.message || "Captcha verification failed");
    }
  };

  handleCaptchaSubmit = (captcha) => {
    this.setState({ showLoader: true });
    let payload = {
      merchant_id: this.state.merchantId,
      secure_token: this.state.secureToken,
      new_password: this.passwordRef.current.value,
      captchaToken: captcha,
    };
    MerchantResetPassword(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          var response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast(
              "succcess",
              "Password reset successfully, login to continue"
            );
            this.props.history.push("/");
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };
  componentWillMount() {
    /* fetching data from url parameters */
    const match = matchPath(this.props.history.location.pathname, {
      path: "/reset-password/:param1/:param2",
      exact: true,
      strict: false,
    });
    console.log("PARAMS : ", match.params);
    this.setState({
      secureToken: match.params.param1,
      merchantId: match.params.param2,
    });
  }

  render() {
    const cardContent = (
      <div className="card form-card" style={{ borderRadius: "10px" }}>
        <div className="card-body cardBody">
          <h4 className="card-title text-center login-title">Reset Password</h4>
          <p className="login-hint-text" style={{ textAlign: "center" }}>
            Enter your new password below to reset your account password.
          </p>
          <form
            className="forms-sample"
            onSubmit={(event) => {
              this.handleResetPassword(event);
            }}
          >
            <div className="login-float-group">
              <div className="input-group">
                <input
                  type={this.state.password}
                  id="resetPassword"
                  ref={this.passwordRef}
                  placeholder=" "
                  onKeyUp={() => this.handlePasswordMatched()}
                />
                <label htmlFor="resetPassword">New Password</label>
                <span
                  className="login-eye-icon"
                  onClick={this.Eye}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    zIndex: 10,
                  }}
                >
                  <i
                    style={{ color: "#888" }}
                    className={`fa ${
                      this.state.eye ? "fa-eye-slash" : "fa-eye"
                    }`}
                  ></i>
                </span>
              </div>
            </div>
            <div className="login-float-group">
              <input
                type="password"
                id="confirmPassword"
                ref={this.confirmPasswordRef}
                placeholder=" "
                onKeyUp={() => this.handlePasswordMatched()}
              />
              <label htmlFor="confirmPassword">Confirm Password</label>
            </div>
            <div className="mb-2">
              {this.state.isPasswordMatched ? (
                <span className="text-success">
                  <i className="mdi mdi-checkbox-marked-circle"></i> Password
                  matched
                </span>
              ) : (
                <span className="text-danger">
                  <i className="mdi mdi-close-circle"></i> Password mismatched
                </span>
              )}
            </div>
            <button type="submit" className="login-btn">
              Reset My Password
            </button>
          </form>
          <PaybitoCaptcha ref={this.captchaRef} sitekey={CAPTCHASITEKEY} />
          <div className="login-links d-flex justify-content-center">
            <span>
              Already a member? <Link to="/">Sign In</Link>
            </span>
          </div>
        </div>
      </div>
    );

    return (
      <Fragment>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{localStorage.getItem(SITENAMEALIAS + "_exchange")}</title>
        </Helmet>

        <nav
          className="navbar navbar-light extNavbar"
          style={{
            backgroundColor: localStorage.getItem(
              SITENAMEALIAS + "_navbarColour"
            ),
          }}
        >
          <div className="image-container">
            <img
              src={localStorage.getItem(SITENAMEALIAS + "_exchangeLogo")}
              className="logo-cred "
            />
          </div>
        </nav>

        {localStorage.getItem(SITENAMEALIAS + "_isBackgroundImage") == "0" ? (
          <div
            className="login-wrapper"
            style={{
              background: localStorage.getItem(
                SITENAMEALIAS + "_backgroundColour"
              ),
            }}
          >
            <br />
            <br />
            <br />
            <br />
            <br />
            <div className="login-background">
              <div className="row mb-3">
                <div className="col-12 text-center"></div>
              </div>
              <div className="row mb-2">
                <div className="col-12 col-sm-12 col-xs-12">{cardContent}</div>
              </div>
            </div>
            {window.location.origin == DEMOBROKER ? (
              <div className="d-flex align-items-end flex-column bd-highlight mb-3 footer-data">
                <a href="https://www.paybito.com/">
                  <div className="btn btn-light mt-auto p-2 bd-highlight footer-data-text">
                    <img
                      src={logo}
                      alt=""
                      style={{ marginRight: 3, height: "30px" }}
                    />
                    Powered by PayBito infrastructure
                  </div>
                </a>
              </div>
            ) : (
              <div></div>
            )}
          </div>
        ) : (
          <div
            className="login-wrapper"
            style={{
              backgroundImage: `url(${localStorage.getItem(
                SITENAMEALIAS + "_backgroundImageLink"
              )})`,
              backgroundRepeat: `no-repeat`,
              backgroundSize: `cover`,
              backgroundPosition: `center`,
              minHeight: `100%`,
            }}
          >
            <br />
            <br />
            <br />
            <br />
            <br />
            <div className="login-background">
              <div className="row mb-3">
                <div className="col-12 text-center"></div>
              </div>
              <div className="row mb-2">
                <div className="col-12 col-sm-12 col-xs-12">{cardContent}</div>
              </div>
            </div>
            {window.location.origin == DEMOBROKER ? (
              <div className="d-flex align-items-end flex-column bd-highlight mb-3 footer-data">
                <a href="https://www.paybito.com/">
                  <div className="btn btn-light mt-auto p-2 bd-highlight footer-data-text">
                    <img
                      src={logo}
                      alt=""
                      style={{ marginRight: 3, height: "30px" }}
                    />
                    Powered by PayBito infrastructure
                  </div>
                </a>
              </div>
            ) : (
              <div></div>
            )}
          </div>
        )}

        <Loader show={this.state.showLoader} />
      </Fragment>
    );
  }
}
